<form [formGroup]="periodForm">
  @if (!deletePeriod) {
    <mat-dialog-content>
      <div class="dialog-header">
        <h2 mat-card-title>Select Period</h2>
        <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @if (!isFullFiscalYearOnly) {
        <div>
          <mat-radio-group class="flex flex-col gap-2" [formControl]="periodForm.controls.periodType">
            <mat-radio-button [value]="PERIOD_TYPE.Quarter" color="primary">Quarter</mat-radio-button>
            <mat-radio-button [value]="PERIOD_TYPE.Semester" color="primary">Semester</mat-radio-button>
            <mat-radio-button [value]="PERIOD_TYPE.FullFiscalYear" color="primary">Full Fiscal Year</mat-radio-button>
            <div class="mt-3 border-t border-gray-200"></div>
            <mat-radio-button [value]="PERIOD_TYPE.LastTwelveMonths" color="primary">Last twelve months</mat-radio-button>
            <mat-radio-button [value]="PERIOD_TYPE.YearToDate" color="primary">Year to date</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (isFullFiscalYearOnly) {
        <div>
          <p>Full Fiscal Year</p>
        </div>
      }
      @if (!isRollingPeriod() && periodForm.get('periodType')?.value) {
        <div
          >
          <mat-form-field>
            @switch (periodForm.controls.periodType.value) {
              <!-- QUARTER -->
              @case (PERIOD_TYPE.Quarter) {
                <mat-select [formControl]="periodForm.controls.periodKeyDate" required>
                  @for (d of quarterEndDates; track d) {
                    <mat-option [value]="d">{{ d | date }}</mat-option>
                  }
                </mat-select>
              }
              <!-- SEMESTER -->
              @case (PERIOD_TYPE.Semester) {
                <mat-select [formControl]="periodForm.controls.periodKeyDate" required>
                  @for (d of semesterEndDates; track d) {
                    <mat-option [value]="d">{{ d | date }}</mat-option>
                  }
                </mat-select>
              }
              <!-- FULL FISCAL YEAR -->
              @case (PERIOD_TYPE.FullFiscalYear) {
                <mat-select [formControl]="periodForm.controls.periodKeyDate" required>
                  @for (d of fullFiscalYearEndDates; track d) {
                    <mat-option [value]="d">{{ d | date }}</mat-option>
                  }
                </mat-select>
              }
            }
            @if (periodForm.controls.periodKeyDate.hasError('required')) {
              <mat-error>Date is required</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div class="mt-3">
        <mat-checkbox formControlName="gpProjected" color="primary">GP Projected</mat-checkbox>
      </div>
      <!-- Rolling Periods LTM, YTD -->
      @if (isRollingPeriod() && periodForm.get('periodType')?.value) {
        <div>
          <mat-form-field>
            <input [matDatepicker]="pickerLtmYtd"
              data-test="period-date-picker"
              formControlName="periodKeyDatePicker"
              matInput>
            <mat-hint>dd/MM/yyyy</mat-hint>
            <mat-datepicker-toggle [for]="pickerLtmYtd" matIconSuffix></mat-datepicker-toggle>
            <mat-datepicker #pickerLtmYtd></mat-datepicker>
          </mat-form-field>
        </div>
      }
    </mat-dialog-content>
  }
</form>

@if (!deletePeriod) {
  <mat-dialog-actions align="end">
    @if (action === ACTION_TYPE.Edit) {
      <button (click)="onDelete()" mat-stroked-button>Delete</button>
    }
    <button
      (click)="onSave()"
        [disabled]="periodForm.controls.periodType.invalid
              || (!isRollingPeriod() && periodForm.controls.periodKeyDate.invalid)
              || (isRollingPeriod() && periodForm.controls.periodKeyDatePicker.invalid)"
      color="primary"
      mat-stroked-button>
      Save
    </button>
  </mat-dialog-actions>
}

<!-- Delete state -->
@if (deletePeriod) {
  <mat-dialog-content>
    <div class="dialog-header">
      <h2 mat-card-title>Delete Period</h2>
      <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <p>Are you sure you want to delete this period?</p>
    <p>{{ originPeriodType }}: {{ originPeriodKeyDate | date }}</p>
  </mat-dialog-content>
}
@if (deletePeriod) {
  <mat-dialog-actions align="end">
    <button (click)="onDeleteConfirm()" mat-stroked-button>Yes</button>
    <button (click)="onDeleteCancel()" color="primary" mat-stroked-button>No</button>
  </mat-dialog-actions>
}
